import { TaskLinkFields } from '@griply/types';

import {
  matchesTaskLinkFilter,
  TaskLinkFilter,
} from './matches-task-link-filter';

// The query cannot narrow on the link arrays (its one array-contains slot is spent on
// `roles.all`), so goal and life-area filters are applied here instead.
export const filterTasksByLinks = <T extends TaskLinkFields>(
  items: T[],
  filter: TaskLinkFilter,
): T[] => {
  // Same reference when nothing is filtered — downstream memo boundaries depend on it.
  if (!filter.goals?.length && !filter.lifeAreas?.length) {
    return items;
  }

  return items.filter((item) => matchesTaskLinkFilter(item, filter));
};
